/** The card shown while the AI works on files (an extraction or a refinement): a spinner, what is happening, a hint. */

import { Loader2 } from 'lucide-react';

import './files.css';

/** `live` announces the text as it changes; a screen with its own status line passes false. */
export function WaitingCard({ text, hint, live = true }: { text: string; hint: string; live?: boolean }) {
  return (
    <div className="card" aria-busy="true">
      <div className="card-body extraction-progress">
        <Loader2 aria-hidden="true" className="spin" />
        <p aria-live={live ? 'polite' : undefined}>{text}</p>
        <p className="hint">{hint}</p>
      </div>
    </div>
  );
}
